
import { SEO } from '../../utils/seo';
import HeroSection from './components/HeroSection';
import IntroSection from './components/IntroSection';
import CloudedTitleSection from './components/CloudedTitleSection';
import LiensSection from './components/LiensSection';
import ProbateSection from './components/ProbateSection';
import BoundarySection from './components/BoundarySection';
import InheritedPropertySection from './components/InheritedPropertySection';
import QuietTitleSection from './components/QuietTitleSection';
import ProcessSection from './components/ProcessSection';
import BenefitsSection from './components/BenefitsSection';
import CaseStudiesSection from './components/CaseStudiesSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import Footer from '../../components/feature/Footer';
import GlobalNavbar from '../../components/feature/GlobalNavbar';

export default function TitleIssuesPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Sell House with Title Issues El Paso | We Buy Properties with Liens"
        description="Have title issues? We buy houses with liens, clouded titles, probate problems, and boundary disputes in El Paso. We handle the title work. Get your cash offer today."
        keywords="sell house with title issues, clouded title buyers, sell house with liens, probate property buyers El Paso, title problems house sale"
        canonical="/title-issues"
        schema={{
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Title Issues Property Buying Service",
          "provider": {
            "@type": "RealEstateAgent",
            "name": "TREX RE LLC"
          },
          "areaServed": "El Paso, TX"
        }}
      />
      <GlobalNavbar />
      <HeroSection />
      <IntroSection />
      <CloudedTitleSection />
      <LiensSection />
      <ProbateSection />
      <BoundarySection />
      <InheritedPropertySection />
      <QuietTitleSection />
      <ProcessSection />
      <BenefitsSection />
      <CaseStudiesSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
}
